import { render, staticRenderFns } from "./ButtonTabs.vue?vue&type=template&id=f9cf8d4c&scoped=true&"
import script from "./ButtonTabs.vue?vue&type=script&lang=ts&"
export * from "./ButtonTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonTabs.vue?vue&type=style&index=0&id=f9cf8d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cf8d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9cf8d4c')) {
      api.createRecord('f9cf8d4c', component.options)
    } else {
      api.reload('f9cf8d4c', component.options)
    }
    module.hot.accept("./ButtonTabs.vue?vue&type=template&id=f9cf8d4c&scoped=true&", function () {
      api.rerender('f9cf8d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/ButtonTabs.vue"
export default component.exports